// extracted by mini-css-extract-plugin
module.exports = {"window":"UnreadChatsModal_window__VAXpO","rightLink":"UnreadChatsModal_rightLink__16aXl"};